import type { SourceAccount, RestoreAccount, Account } from '@repo/api-gw-sdk';

import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';
import { getAccountProvider } from '@/utils/accounts';

import { TextDetailsTuple } from '../text/textDetailsTuple';

export const AccountIndicator = ({
  account,
  showCloudIndicator = true,
  showAccountName = true,
  showAccountId = true,
  copyable = true,
}: {
  account: Account | SourceAccount | RestoreAccount;
  showCloudIndicator?: boolean;
  showAccountName?: boolean;
  showAccountId?: boolean;
  copyable?: boolean;
}) => {
  const cloudProvider = getAccountProvider(account);

  return showCloudIndicator ? (
    <CloudProviderIndicator
      cloudProvider={cloudProvider}
      text={
        <Tuple
          showAccountName={showAccountName}
          showAccountId={showAccountId}
          account={account}
          copyable={copyable}
        />
      }
    />
  ) : (
    <Tuple
      showAccountName={showAccountName}
      showAccountId={showAccountId}
      account={account}
      copyable={copyable}
    />
  );
};

const Tuple = ({
  showAccountName,
  showAccountId,
  account,
  copyable = true,
}: {
  showAccountName?: boolean;
  showAccountId?: boolean;
  account: Account | SourceAccount | RestoreAccount;
  copyable?: boolean;
}) => {
  const gwsDomain =
    'restoreAccountAttributes' in account
      ? account.restoreAccountAttributes.googleWorkspace?.primaryDomain
      : undefined;

  return (
    <TextDetailsTuple
      primaryProp={showAccountName ? account.name : undefined}
      secondaryProp={
        showAccountId ? gwsDomain || account.providerAccountId : undefined
      }
      copyable={copyable}
    />
  );
};
